export default __webpack_public_path__ + "static/media/Icon22.a016923d.png";